import {Box} from '@mui/system';
import {useTranslation} from 'react-i18next';

import PaymentLinkFeesItem from '@/app/shared-components/PaymentLinkFeesItem/PaymentLinkFeesItem';

import {getIcon} from '../utils/PaymentLinkUtils';
import {usePaymentLinkViewModelProvider} from '../ViewModelContext';

export const PaymentLinkFees = ({fees, disable = false}) => {
  const {t} = useTranslation();
  const {handleFeeOptionSelected} = usePaymentLinkViewModelProvider();

  return (
    <Box className="payment-link-fees-container">
      <Box>
        {fees &&
          fees.map((fee, index) => (
            <PaymentLinkFeesItem
              key={index}
              icon={getIcon(fee.type)}
              flat_fee={fee.flat_fee}
              percentage_fee={fee.percentage_fee || undefined}
              onPress={() => {
                handleFeeOptionSelected(fee);
              }}
              disable={disable}
              title={
                {
                  debit: t('payment_link.fees.debit_card'),
                  credit: t('payment_link.fees.credit_card'),
                  apple: t('payment_link.fees.apple'),
                  google: t('payment_link.fees.google'),
                  venmo: t('payment_link.fees.venmo'),
                }[fee.type] || t('payment_link.fees.unknown')
              }
            />
          ))}
      </Box>
    </Box>
  );
};
